import axios from 'axios';
import { setUser } from 'redux/authSlice';
import { Dispatch } from 'redux';
import apiInstance from './RefeshTokenInstance';

const API_BASE_URL = `${process.env.REACT_APP_BASE_URL}/api`;
interface Credentials {
  email: string;
  password: string;
}

export const checkAuth = async (dispatch: Dispatch) => {
  const API_URL = `${API_BASE_URL}/protected`;
  try {
    const response = await apiInstance.get(API_URL);
    dispatch(setUser(response.data.user));
    return response;
  } catch (error: any) {
    console.error('Auth Check Error:', error.response || error);
    throw error;
  }
};

export const loginUser = async (credentials: Credentials) => {
  const API_URL = `${API_BASE_URL}/login`;
  try {
    const response = await axios.post(API_URL, credentials, {
      withCredentials: true
    });

    return response;
  } catch (error) {
    throw error;
  }
};


export const registerUser = async (credentials: Credentials) => {
  const API_URL = `${API_BASE_URL}/submit`;

  try {
    const response = await axios.post(API_URL, credentials, {
      withCredentials: true
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const forgotPassword = async (email: string) => {
  const API_URL = `${API_BASE_URL}/forgetPassoword`;
  try {
    const response = await axios.post(API_URL, { email });
    return response;
  } catch (error) {
    throw error;
  }
};

export const validateResetToken = async (token: string): Promise<any> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/validate-reset-token`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (
  token: string,
  passwordData: { password: string; confirmPassword: string }
): Promise<any> => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/resetpassword`,
      passwordData,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const logoutUser = async () => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/logout`,
      {},
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    console.error('Logout failed:', error);
    throw error;
  }
};
